export const selectMembershipOrderItem = (order) =>
  order?.orderItems?.find((o) => o.type === 'MembershipOrderItem');
